import React from 'react'
import type { WrappedStoryState } from './wrappedStoryStateReducer'
import { INITIAL_WRAPPED_STORY_STATE } from './wrappedStoryStateReducer'

const WrappedStoryStateContext = React.createContext<WrappedStoryState>(INITIAL_WRAPPED_STORY_STATE)

export default WrappedStoryStateContext
